import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css'
import request from "./utils/request";
import * as echarts from 'echarts';
//修改弹出框样式
import './utils/dialog'
import moment from "moment";
//引入中文包
import 'moment/locale/zh-cn';
import {Message} from 'element-ui'


Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.prototype.$echarts = echarts;

Vue.prototype.$axios = axios;

Vue.prototype.$moment = moment;

Vue.prototype.request = request

Vue.prototype.$message = function(msg){
  return Message({
    offset:65,
    message: msg,
    duration: 2000
  })
}
//分别对success、warning和error等样式进行设置
Vue.prototype.$message.success = function (msg) {
  return Message.success({
    offset:65,
    message: msg,
    duration: 2000
  })
}
Vue.prototype.$message.warning = function (msg) {
  return Message.warning({
    offset:65,
    message: msg,
    duration: 2000
  })
}
Vue.prototype.$message.error = function (msg) {
  return Message.error({
    offset:65,
    message: msg,
    duration: 2000
  })
}
Vue.prototype.$message.info = function (msg) {
  return Message.info({
    offset:65,
    message: msg,
    duration: 2000
  })
}
new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  render: h => h(App)
}).$mount('#app')
